export default __webpack_public_path__ + "static/media/simTransfer-5.acfb82cf.png";